module.exports = __webpack_public_path__ + "img/s6.cb1d7268.png";